import { userContext } from '../userManager';
import { getStartAndEndDateByTag } from '../../utils/dates';

export const apiMandatesGet = ({ riskProfile, types } = {}) =>
  userContext.apiCall({
    url: `/mandates`,
    method: 'GET',
    qs: {
      riskProfileLevel: riskProfile?.riskLevel,
      types: types?.map((t) => t.description).join(','),
    },
  });

export const apiMandatesHoldingsGet = (id) =>
  userContext.apiCall({ url: `/mandates/${id}/holdings` });

export const apiMandatesDetailsGet = (id) => userContext.apiCall({ url: `/mandates/${id}` });

export const apiMandatesPost = ({ riskProfileId, name, mandateTypeName }) =>
  userContext.apiCall({
    url: `/mandates`,
    method: 'POST',
    body: {
      riskProfileId,
      name,
      mandateTypeName,
      isProduct: true,
    },
  });

export const apiMandatesImportQuotesPost = (id, { file }) =>
  userContext.apiCall({
    url: `/mandates/${id}/import-quotes`,
    method: 'POST',
    file,
  });

export const apiMandatesPatch = (mandateId, { published }) =>
  userContext.apiCall({
    url: `/mandates/${mandateId}`,
    method: 'PATCH',
    body: { published },
  });

export const apiMandatesHoldingsPost = (id, { instrumentId, weight }) =>
  userContext.apiCall({
    url: `/mandates/${id}/holdings`,
    method: 'POST',
    body: {
      instrumentId,
      weight,
    },
  });

export const apiMandatesHoldingsPatch = (id, { holdings }) =>
  userContext.apiCall({
    url: `/mandates/${id}/holdings`,
    method: 'PATCH',
    body: { holdings },
  });

export const apiMandatePerformanceGet = (
  mandateId,
  { benchmarkId, yearsTag, startDate, compareIds }
) => {
  let newStartDate = startDate;
  if (yearsTag) {
    newStartDate = getStartAndEndDateByTag(yearsTag).startDate;
  }

  return userContext.apiCall({
    url: `/mandates/${mandateId}/performances`,
    qs: {
      compareInstrumentIds: compareIds ?? '',
      benchmarkId,
      startDate: newStartDate,
    },
  });
};

export const apiMandatesKpisGet = (id) => userContext.apiCall({ url: `/mandates/${id}/kpis` });

export const apiMandatesMaxDrawdownGet = ({
  mandateId,
  startDate,
  endDate,
  benchmarkId,
  samplingInterval,
}) =>
  userContext.apiCall({
    url: `/mandates/${mandateId}/max-drawdown`,
    qs: { startDate, endDate, benchmarkIndexId: benchmarkId, samplingInterval },
  });

export const apiMandatesDetails = (mandateIds) =>
  userContext.apiCall({
    url: `/mandates/details`,
    method: 'POST',
    body: { mandateIds },
  });

export const apiMandatesOptimizationGet = (id, { targetReturn, forceRetry }) =>
  userContext.apiCall({
    url: `/mandates/${id}/optimization`,
    method: 'GET',
    qs: { targetReturn, forceRetry },
    qsOptions: { skipNull: true },
  });
